/* Knowledge Base Charter links */
export const charterLinks = [
	{
		title: 'Business Glossary',
		path: 'knowledgeBase/article/content?path=/knowledge-base/WMT-US/SUPPLIER/article-page/CHANNEL_PERFORMANCE/chp-resources/rb-glossary/en_us/rb-glossary'
	},
	{
		title: 'Build Your Report',
		path: 'knowledgeBase/article/content?path=/knowledge-base/WMT-US/SUPPLIER/article-page/CHANNEL_PERFORMANCE/report-builder/build-your-report/en_us/build-your-report'
	},
	{
		title: 'Quick Report',
		path: 'knowledgeBase/article/content?path=/knowledge-base/WMT-US/SUPPLIER/article-page/CHANNEL_PERFORMANCE/report-builder/quick-report/en_us/quick-report'
	},
	{
		title: 'Vendor Scorecard',
		path: 'knowledgeBase/article/content?path=/knowledge-base/WMT-US/SUPPLIER/article-page/CHANNEL_PERFORMANCE/report-builder/vendor-scorecard/en_us/vendor-scorecard'
	},
	{
		title: 'Linked Items Activity',
		path: 'knowledgeBase/article/content?path=/knowledge-base/WMT-US/SUPPLIER/article-page/CHANNEL_PERFORMANCE/report-builder/link-itms-act/en_us/link-itms-act'
	},
	{
		title: 'Schedule/Run Your Reports',
		path: 'knowledgeBase/article/content?path=/knowledge-base/WMT-US/SUPPLIER/article-page/CHANNEL_PERFORMANCE/report-builder/sched-run-rpts/en_us/sched-run-rprts'
	},
	{
		title: 'Dataset Overview',
		path: 'knowledgeBase/articles?path=/knowledge-base/WMT-US/SUPPLIER/category-page/CHANNEL_PERFORMANCE/en_us/channel-performance-category-page'
	},
	{
		title: 'Dataset-at-a-Glance',
		path: 'knowledgeBase/article/content?path=/knowledge-base/WMT-US/SUPPLIER/article-page/CHANNEL_PERFORMANCE/report-builder/data-glance/en_us/data-glance'
	},
	{
		title: 'FAQs',
		path: 'knowledgeBase/article/content?path=/knowledge-base/WMT-US/SUPPLIER/article-page/CHANNEL_PERFORMANCE/chp-resources/chp-faqs/en_us/chp-faqs'
	},
	{
		title: 'Register-sales-learn-more',
		path: 'knowledgeBase/article/content?path=/knowledge-base/WMT-US/SUPPLIER/article-page/CHANNEL_PERFORMANCE/dataset-overview/register-sales/en_us/register-sales'
	}
];

/* Knowledge Base Basic links */
export const basicLinks = [
	{
		title: 'Introduction to Report Builder',
		path: 'knowledgeBase/basic/article?titleLink=knowledge-base-basic-users%2Farticle-landing-page%2Fintroduction-to-report-builder'
	},
	{
		title: 'Dataset Overview & Sample Reports',
		path: 'knowledgeBase/basic/article?titleLink=knowledge-base-basic-users%2Farticle-landing-page%2Fdataset-overview-%26-sample-reports'
	},
	{
		title: 'Using the Canvas Screen',
		path: 'knowledgeBase/basic/article?titleLink=knowledge-base-basic-users%2Farticle-landing-page%2Fusing-the-canvas-screen'
	},
	{
		title: 'Building a Report',
		path: 'knowledgeBase/basic/article?titleLink=knowledge-base-basic-users%2Farticle-landing-page%2Fbuilding-a-report'
	},
	{
		title: 'Scheduling, Managing & Editing Reports',
		path: 'knowledgeBase/basic/article?titleLink=knowledge-base-basic-users%2Farticle-landing-page%2Fmanage-reports'
	},
	{
		title: 'Attributes & Business Glossary',
		path: 'knowledgeBase/basic/article?titleLink=knowledge-base-basic-users%2Farticle-landing-page%2Fattributes-%26-business-glossary'
	},
	{
		title: 'Report Builder Basic FAQ',
		path: 'knowledgeBase/basic/article?titleLink=knowledge-base-basic-users%2Farticle-landing-page%2Freport-builder-basic-faq'
	}
];
